<template>
    <b-container fluid style="background-color: white; padding: 3px;">
        <b-row>
            <b-col><h4 class="text-themecolor">{{ $t('fmweb.aantal')}} ({{ count }})</h4></b-col>
            <b-col md="6" class="my-1">
                <b-form-group
                        label-cols-sm="3"
                        label-size="sm"
                        class="mb-1">
                    <b-input-group size="sm">
                        <b-form-input
                                v-model="filter"
                                type="search"
                                id="filterInput"
                                :placeholder="$t('fmweb.zoekenPlaceholder')"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">{{$t('fmweb.zoekenLeegMaken')}}</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-table v-if="windowSize < 992" class="table-invoices d-table d-lg-none" 
            id="table-small"
            hover
            outlined
            no-border-collapse
            show-empty
            :items="invoices"
            :fields="fieldsSmall"
            ref="invoicesTable"
            selectable
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :select-mode="selectMode"
            :busy="count == -1"
            primary-key="documentId"
            @row-selected="onRowSelected"
            @row-clicked="expandAdditionalInfo"
            @filtered="onFiltered">
                <template v-slot:cell(selected)="{rowSelected}">
                    <template v-if="rowSelected">
                        <span aria-hidden="true"><i class="fas fa-long-arrow-alt-right"></i></span>
                        <span class="sr-only">{{$t('fmweb.geselecteerd')}}</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">{{$t('fmweb.nietGeselecteerd')}}</span>
                    </template>
                </template>
                <template v-slot:cell(creditor)="row">{{ row.item.creditor.name }}</template>
                <template v-slot:cell(invoiceDate)="row">{{ row.item.invoiceDate | date }}</template>
                <template v-slot:cell(totalAmount)="row">{{ row.item.currency }} {{ row.item.totalAmount }}</template>
                <template v-slot:cell(additionalInfoIcon)="row">
                    <i v-show="!row.item._showDetails" class="fas fa-chevron-down"></i>
                    <i v-show="row.item._showDetails" class="fas fa-chevron-up"></i>
                </template>
                <template v-slot:row-details="row">
                    <b-card>
                        <InvoiceDetails
                                v-bind:selectedInvoiceId="row.item.id"
                                v-bind:row="row"
                                @nextInvoice="toInvoice($event)"
                                @previousInvoice="toInvoice($event)"
                                @invoiceApproval="setApproval($event)"/>
                    </b-card>
                </template>
                <template v-slot:table-busy>
                    <PreLoader/>
                </template>
                <template #empty>
                    {{$t('fmweb.geenfacturen')}}
                </template>                
        </b-table>
        <b-table v-if="windowSize >= 992" class="table-invoices d-none d-lg-table" 
            id="table-small"
            hover
            outlined
            no-border-collapse
            show-empty
            :items="invoices"
            :fields="fieldsLarge"
            ref="invoicesTable"
            selectable
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :select-mode="selectMode"
            :busy="count == -1"
            primary-key="documentId"
            @row-selected="onRowSelected"
            @row-clicked="expandAdditionalInfo"
            @filtered="onFiltered">
                <template v-slot:cell(selected)="{rowSelected}">
                    <template v-if="rowSelected">
                        <span aria-hidden="true"><i class="fas fa-long-arrow-alt-right"></i></span>
                        <span class="sr-only">{{$t('fmweb.geselecteerd')}}</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">{{$t('fmweb.nietGeselecteerd')}}</span>
                    </template>
                </template>
                <template v-slot:cell(documentId)="row">{{ row.item.documentId }}</template>
                <template v-slot:cell(statusValue)="row">{{ row.item.statusValue }}</template>
                <template v-slot:cell(creditor)="row">{{ row.item.creditor.name }}</template>
                <template v-slot:cell(invoiceDate)="row">{{ row.item.invoiceDate | date }}</template>
                <template v-slot:cell(totalAmount)="row">{{ row.item.currency }} {{ row.item.totalAmount }}</template>
                <template v-slot:cell(additionalInfoIcon)="row">
                    <i v-show="!row.item._showDetails" class="fas fa-chevron-down"></i>
                    <i v-show="row.item._showDetails" class="fas fa-chevron-up"></i>
                </template>
                <template v-slot:row-details="row">
                    <b-card>
                        <InvoiceDetails
                                v-bind:selectedInvoiceId="row.item.id"
                                v-bind:row="row"
                                @nextInvoice="toInvoice($event)"
                                @previousInvoice="toInvoice($event)"
                                @invoiceApproval="setApproval($event)"/>
                    </b-card>
                </template>
                <template v-slot:table-busy>
                    <PreLoader/>
                </template>
                <template #empty>
                    {{$t('fmweb.geenfacturen')}}
                </template>                 
        </b-table>
        <b-row>
            <b-col>
                <b-col align-self="center" sm="8" md="6" lg="9" class="my-1">
                    <b-form-group label-cols-sm="5" label-cols-lg="3" :label="$t('fmweb.aantalItems')"  label-for="perPageSelect">
                        <b-form-select
                                v-model="perPage"
                                id="perPageSelect"
                                size="md"
                                :options="pageOptions">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-col>
            <b-col v-if="windowSize >= 992" align-self="center" sm="5" md="6" class="my-1 fm d-none d-md-block">
                <b-pagination
                        class="customPagination"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        :first-text="$t('fmweb.eerste')"
                        :next-text="$t('fmweb.volgende')"
                        :next-class="nextPageClass"
                        :last-text="$t('fmweb.laatste')"
                        :prev-text="$t('fmweb.vorige')"
                        :prev-class="prevPageClass"
                        align="center"
                        size="md"
                ></b-pagination>               
            </b-col>
            <b-col v-if="windowSize < 992" align-self="center" sm="5" md="6" class="my-1 fm d-xs-block d-sm-block d-md-none">
                <b-pagination
                        class="customPagination"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        :next-class="nextPageClass"
                        :prev-class="prevPageClass"
                        align="center"
                        size="md"
                ></b-pagination>                
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import InvoiceDetails from "@/components/fmwebapp/InvoiceDetails";
    import { mapGetters, mapActions } from "vuex";
    import $ from "jquery";
    import { uuidMixin } from "../../../mixins/uuidMixin"
    import ApproveCommand from "./approveCommand";
    import PreLoader from '@/components/root/Preloader';

    export default {
        name: "invoices-index",
        mixins: [ uuidMixin ],
        components: {InvoiceDetails, PreLoader},
        data() {
            return {
                search: '',
                rowIndex: 1,
                command: {},
                count: -1,
                windowSize: $(window).width(),
                approveCommand: new ApproveCommand(),
                selectedInvoiceId: null,
                page: 1,
                itemsPerPage: 8,
                currentPage: 1,
                perPage: 25,
                nextPageClass: "next-page-button",
                prevPageClass: "prev-page-button",
                pageOptions: [10, 25, 50, 100, 250],
                sortBy: 'documentId',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                profile: this.$auth.profile,
                selectMode: 'single',
                selected: []
            }
        },
        computed: {
            ...mapGetters('fmwebapp',['invoices']),
            numberOfPages () {
                return Math.ceil(this.invoices.length / this.itemsPerPage)
            },
            fieldsLarge (){
                return [
                    { key: 'selected', label: "#", tdClass: 'pr-0 pl-0' },
                    { key: 'documentId', label: this.$t('fmweb.documentid'), sortable: true },
                    { key: 'statusValue', label: this.$t('fmweb.status'), sortDirection: 'desc' },
                    { key: 'creditor.name', label: this.$t('fmweb.crediteur'), sortable: true, tdClass: 'pr-0 pl-0' },
                    { key: 'invoiceDate', label: this.$t('fmweb.datum'), sortByFormatted: true, filterByFormatted: true, sortable: true, tdClass: 'pr-0 pl-0' },
                    { key: 'totalAmount', label: this.$t('fmweb.prijs'), tdClass: 'pr-0 pl-0' },
                    { key: 'additionalInfoIcon', label: '', tdClass: 'pr-0 pl-0'}
                ]
            },
            fieldsSmall (){
                return [
                    { key: 'selected', label: "#", tdClass: 'pr-0 pl-0' },
                     { key: 'creditor.name', label: this.$t('fmweb.crediteur'), sortable: true, tdClass: 'pr-0 pl-0' },
                    { key: 'invoiceDate', label: this.$t('fmweb.datum'), sortByFormatted: true, filterByFormatted: true, sortable: true, tdClass: 'pr-0 pl-0' },
                    { key: 'totalAmount', label: this.$t('fmweb.prijs'), tdClass: 'pr-0 pl-0' },
                    { key: 'additionalInfoIcon', label: '', tdClass: 'pr-0 pl-0'}
                ]
            },            
            rows() {
                return this.invoices.length
            }
        },
        methods: {
            ...mapActions('fmwebapp',['all', 'update', 'execute']),
            nextPage () {
                if (this.page + 1 > this.numberOfPages) {
                    $("#nextPageButton").prop("disabled", true);
                } else {
                    this.page += 1;
                    $("#previousPageButton").prop("disabled", false);
                }
            },
            expandAdditionalInfo(row) {
                var rowShowDetails = row._showDetails
                var vm = this;
                var store = this.$store;
                
                this.invoices.forEach(function(element) {
                    vm.showDetails(store, element, false)
                });
                                
                this.showDetails(this.$store, row, !rowShowDetails)
            },
            showDetails(store, element, showDetails) {
                    var elementPatch = {
                        _showDetails: showDetails
                    }   

                    store.commit('fmwebapp/update', {
                        resource: "invoices",
                        result: { ...element, ...elementPatch }
                    })
            },
            previousPage () {
                if (this.page - 1 >= 1) {
                    this.page -= 1
                    $("#nextPageButton").prop("disabled", false);
                } else {
                    $("#previousPageButton").prop("disabled", true);
                }
            },
            updateItemsPerPage (number) {
                this.itemsPerPage = number
            },
            showAllItems () {
                if ($('#mobileFooter:visible').length == 0) {
                    this.updateItemsPerPage(this.invoices.length);
                } else {
                    this.updateItemsPerPage(8);
                }
            },
            info(item, index, button) {
                this.infoModal.title = `Row index: ${index}`
                this.infoModal.content = JSON.stringify(item, null, 2)
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            resetInfoModal() {
                this.infoModal.title = ''
                this.infoModal.content = ''
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            changeStatusIcon: function (status) {
                var iconLink = "";
                switch (status) {
                    case "Concept":
                        iconLink = "far fa-file";
                        break;
                    case "Duplicate":
                        iconLink = "far fa-copy";
                        break;
                    case "ReadyForProcessing":
                        iconLink = "fas fa-bell";
                        break;
                    case "Processed":
                        iconLink = "far fa-check-square";
                }
                return iconLink;
            },
            onRowSelected(items) {
                this.selected = items
            },
            calculatePageNumber(itemsPerPage, itemIndex) {
                const pageNumber = Math.ceil(itemIndex / itemsPerPage)
                const totalPages = Math.ceil(this.invoices.length / itemsPerPage)
                if(pageNumber > totalPages) {
                    return totalPages
                }
                return pageNumber
            },
            async toInvoice( direction ) {
                const table = document.querySelector(`.table-invoices.b-table-selecting tbody`)
                const selectedItems = table.querySelectorAll('tr[aria-selected="true"]')
                const itemsPerPage = this.perPage
                const currentPage = this.currentPage
                const totalItems = this.totalRows

                if(selectedItems.length > 0) {
                    const selectedItemIndex = parseInt(selectedItems[0].ariaRowIndex)
					let newItemIndex = selectedItemIndex

                    if (isNaN(selectedItemIndex)) { return }
					if(direction !== 'nextWithApprove') {
						newItemIndex = direction === 'next' ? selectedItemIndex + 1 : selectedItemIndex - 1
					}
                    if(newItemIndex > 0 && newItemIndex <= totalItems) {
                        const newItemPage = this.calculatePageNumber(itemsPerPage, newItemIndex)
                        if(currentPage !== newItemPage) {
                            this.currentPage = newItemPage
                            await this.$nextTick()
                        }
						await this.$nextTick()
                        $('[aria-rowindex="' + newItemIndex + '"]').trigger('click')
                    } else {
                        this.$refs.invoicesTable.clearSelected()
                    }
                }
            },
            setApproval(currentInvoice) {
                const vm = this;
                const documentId = currentInvoice.item.documentId

                const payload = {
                    resource: "invoices",
                    id: documentId,
                    action: "approve",
                    params: vm.approveCommand
                }

                vm.execute(payload)
            },
            onResize() {
                this.windowSize = $(window).width();
            }                                    
        },
        watch: {
            invoices: function(value) {
                this.count = value.length;
            }
        },
        created() {
            var vm = this;
            vm.all({
                resource: 'invoices',
                queryParameters: [
                    {key: '$top', value: 250},
                    {key: '$count', value: true},
                    {key: '$orderby', value: 'documentId%20asc'}
                ]
            }).then(() => {
                    vm.totalRows = vm.invoices.length;
            });
            window.addEventListener('resize', this.onResize)
        },
        destroyed() {
            window.removeEventListener('resize', this.onResize)
        }         
    }
</script>
<style scoped>
    .headerItems{
        text-align: center;
    }

    ::v-deep.customPagination > li.active > a,
    ::v-deep.customPagination > li > a:hover {
        color: white;
        background-color: #7abd59;
        border: 1px solid grey;
    }

    @-webkit-keyframes rotationOpen {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(180deg);
        }
    }

    @-webkit-keyframes rotationClose {
        from {
            -webkit-transform: rotate(180deg);
        }
        to {
            -webkit-transform: rotate(0deg);
        }
    }

    @media only screen and (max-width: 510px) {
        #pagingMenu{
            margin-top: 10%;
        }

        #desktopHeader{
            display: none;
        }

        #mobileFooter {
            display: none;
        }
    }
</style>